
import { createSlice } from '@reduxjs/toolkit';

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    isAuthenticated: true,
    isUserAuthenticated: true,

    
  },
  reducers: {
    toggleCategoriesSidenav: (state) => {
      state.isCategoriesSidenavOpen = !state.isCategoriesSidenavOpen;
    },
    toggleAuthentication: (state) => {
      state.isAuthenticated = !state.isAuthenticated;
    },
    toggleUserAuthentication: (state) => {
      state.isUserAuthenticated = !state.isUserAuthenticated;
    },
  },
});

export const { toggleCategoriesSidenav, toggleAuthentication ,toggleUserAuthentication} = adminSlice.actions;
export default adminSlice.reducer;
